if (!customElements.get('media-gallery')) {
	customElements.define('media-gallery', class MediaGallery extends HTMLElement {
		constructor() {
			super()
			this.selectors = {
				mediaGallery: '[id^=Media-Gallery]',
				liveRegion: '[id^="GalleryStatus"]',
				viewer: '[id^="GalleryViewer"]',
				thumbnailsWrapper: '.f-product__media-thumbnails-wrapper',
				thumbnails: '[id^="GalleryThumbnails"]',
				thumbnailItems: ['[id^="GalleryThumbnailItem"]'],
				videos: ['.f-video__embed'],
				models: ['product-model'],
				medias: ['.f-product__media'],
				xrButton: '[data-first-xr-button]',
				sliderCounter: '.flickity-counter--current',
				toggleZoom: ['.js-photoswipe--zoom']
			}

      let touchingCarousel = false;
      let startXCoordinate

      document.body.addEventListener('touchstart', (e) => {
        if (e.target.closest('.flickity-slider')) {
          touchingCarousel = true;
        } else {
          touchingCarousel = false;
          return;
        }
        startXCoordinate = e.touches[0].pageX;
      }, {passive: true});

      document.body.addEventListener(
        'touchmove',
        (e) => {
          if (touchingCarousel && e.cancelable) {
            if (Math.abs(e.touches[0].pageX - startXCoordinate) > 10) {
              e.preventDefault();
            }
          }
        },
        { passive: false }
      );
		}

		connectedCallback() {
			this.init()
		}

		disconnectedCallback() {
			clearInterval(this.check)
		}

		init() {
			this.domNodes = queryDomNodes(this.selectors, this)
			this.mediaLayout = this.domNodes.mediaGallery.dataset.mediaLayout
			this.onlyImage = this.dataset.onlyImage === 'true'
			this.enableZoom = this.dataset.enableZoom === 'true'
			this.enableVariantGroupImages = this.dataset.enableVariantGroupImages === 'true'
			if (this.onlyImage) this.removeAttribute('data-media-loading')
			if (this.mediaLayout === 'carousel') {
				this.domNodes.thumbnails && this.domNodes.thumbnails.initSlider()
				this.initGallerySlider()
			} else {
				const allMediaAnimate = this.domNodes.mediaGallery.querySelectorAll('.f-scroll-trigger')
				if (FoxThemeSettings.isMobile) {
					this.domNodes.mediaGallery && this.domNodes.mediaGallery.initSlider()
					this.domNodes.thumbnails && this.domNodes.thumbnails.initSlider()
					if (allMediaAnimate.length > 0) {
						allMediaAnimate.forEach(media => {
							media.classList.remove('f-scroll-trigger')
						})
					}
				}
				document.addEventListener('matchMobile', () => {
					this.domNodes.mediaGallery && this.domNodes.mediaGallery.initSlider()
					this.domNodes.thumbnails && this.domNodes.thumbnails.initSlider()
					if (allMediaAnimate.length > 0) {
						allMediaAnimate.forEach(media => {
							media.classList.remove('f-scroll-trigger')
						})
					}
				})
				document.addEventListener('unmatchMobile', () => {
					this.domNodes.mediaGallery && this.domNodes.mediaGallery.destroy()
					this.domNodes.thumbnails && this.domNodes.thumbnails.destroy()
					if (allMediaAnimate.length > 0) {
						allMediaAnimate.forEach(media => {
							media.classList.remove('f-scroll-trigger')
						})
					}
				})
				if (this.enableZoom) this.initImageZoom()
			}
			if (this.onlyImage && this.enableZoom) this.initImageZoom()

			if( ! this.enableVariantGroupImages ) {
				this.removeAttribute('data-media-loading')
			}

			this.initProductAutoplayVideoControls()
		}

		update() {
			if (this.domNodes.mediaGallery) this.domNodes.mediaGallery.update()
			if (this.domNodes.thumbnails) this.domNodes.thumbnails.update()
		}

		initGallerySlider() {
			if (!this.domNodes.medias.length) return
			this.selectedSlide = null
			this.selectedMediaType = ''
			this.check = setInterval(() => {
				this.mediaGallery = this.domNodes.mediaGallery.slider && this.domNodes.mediaGallery.slider.instance
				this.thumbnails = this.domNodes.thumbnails && this.domNodes.thumbnails.slider && this.domNodes.thumbnails.slider.instance

				if (this.mediaGallery && typeof this.mediaGallery == 'object') {
					clearInterval(this.check)
					this.mediaGallery.on('change', this.onSlideChanged.bind(this))

					if (this.thumbnails) {
						if (this.thumbnails.cells && this.thumbnails.cells[0]) this.thumbnails.select(0)
						this.handleScreenChange()
					}
					if (this.enableZoom) this.initImageZoom()
				}
			}, 100)
			const bar = document.querySelector('#GalleryThumbnails-product-quickview')
			if (bar) {
				bar.destroy()
			}

			const elementsToClick = document.querySelectorAll( '.f-product__media-thumbnails-item' );

			for ( let i = 0; i < elementsToClick.length; i++ ) {
				elementsToClick[i].addEventListener( 'click' , this.changeSlide )
			}
		}

		changeSlide( event ) {
			const elementsToClick = document.querySelectorAll( '.f-product__media-thumbnails-item' );

			for ( let i = 0; i < elementsToClick.length; i++ ) {
				elementsToClick[i].classList.remove("is-selected-custom")
			}

			let correctedSlide = event.target
			if (!correctedSlide.hasAttribute('data-thumbnail-index')) {
				correctedSlide = correctedSlide.closest('[data-thumbnail-index]')
			}

			if (correctedSlide != null) {
				const selectedSlideIndex = correctedSlide.getAttribute( 'data-thumbnail-index' );

				correctedSlide.classList.add("is-selected-custom")

				if ( selectedSlideIndex != null ) {
					 const sliderOption = document.querySelector('[data-slider-options]')
					 sliderOption.select(selectedSlideIndex)
				}
			}
		}

		getVisibleMediaGallery() {
			const galleries = [...this.querySelectorAll('.f-product__media-list')];

			return galleries.find((gallery) => {
				return window.getComputedStyle(gallery).display !== 'none';
			}) || this;
		}

		buildZoomDataSource(root) {
			const dataSource = [];

			if (!root) return dataSource;

			const mediaItems = root.querySelectorAll('.f-product__media');

			mediaItems.forEach((media) => {
				const mediaType = media.dataset.mediaType;

				const mediaData = {
					id: media.dataset.mediaIndex,
					mediaId: media.dataset.mediaId,
					mediaType,
				};

				if (mediaType === 'image') {
					dataSource.push({
						...mediaData,
						src: media.dataset.src,
						width: media.dataset.pswpWidth,
						height: media.dataset.pswpHeight,
					});

					return;
				}

				if (mediaType === 'model') {
					const productModel = media.querySelector('product-model');
					if (!productModel) return;

					dataSource.push({
						...mediaData,
						html: `<div class="pswp__item--${mediaType}">${productModel.outerHTML}</div>`,
					});

					return;
				}
				if (mediaType === 'video' || mediaType === 'external_video') {
					const deferredMedia = media.querySelector('deferred-media');
					if (!deferredMedia) return;

					const deferredMediaClone = deferredMedia.cloneNode(true);

					deferredMediaClone
						.querySelectorAll('[data-product-video-autoplay-toggle]')
						.forEach((button) => {
						delete button.dataset.productVideoAutoplayToggleInitialized;
					});

					dataSource.push({
						...mediaData,
						html: `<div class="pswp__item--${mediaType}">${deferredMediaClone.outerHTML}</div>`,
					});
				}
			});

			return dataSource;
		}

		getZoomMediaElement(data) {
			const root = this.zoomMediaRoot || this.getVisibleMediaGallery();
			if (!root || !data) return null;

			if (data.mediaId) {
				const mediaById = root.querySelector(`[data-media-id="${data.mediaId}"]`);
				if (mediaById) return mediaById;
			}

			if (data.id) {
				return root.querySelector(`[data-media-index="${data.id}"]`);
			}

			return null;
		}

		initImageZoom() {
			const zoomMediaRoot = this.getVisibleMediaGallery();
			this.zoomMediaRoot = zoomMediaRoot;
			const dataSource = this.buildZoomDataSource(zoomMediaRoot);

			const options = {
				dataSource: dataSource,
				pswpModule: window.FoxTheme.PhotoSwipe,
				bgOpacity: 1,
				arrowPrev: false,
				arrowNext: false,
				zoom: false,
				close: false,
				counter: false,
				preloader: false
			}

			this.lightbox = new window.FoxTheme.PhotoSwipeLightbox(options)

			this.lightbox.addFilter('thumbEl', (thumbEl, data, index) => {
				const mediaElement = this.getZoomMediaElement(data)
				const el = mediaElement && mediaElement.querySelector('img');
				if (el) {
					return el;
				}
				return thumbEl;
			});

			this.lightbox.addFilter('placeholderSrc', (placeholderSrc, slide) => {
				const mediaElement = this.getZoomMediaElement(slide.data)
				const el = mediaElement && mediaElement.querySelector('img');
				if (el) {
					return el.src;
				}
				return placeholderSrc;
			});

			this.lightbox.on('change', () => {
				const currIndex = this.lightbox.pswp.currIndex
				if (!this.onlyImage) {
					const sliderComponent = this.zoomMediaRoot || this.domNodes.mediaGallery
					const slider = sliderComponent.slider && sliderComponent.slider.instance
					if (slider) {
						setTimeout(() => {
							slider.select(currIndex, false, true)
						}, 300)
					}
				}
			});

			this.lightbox.on('change', () => {
				this.initProductAutoplayVideoZoomControls()
			});

			this.lightbox.on('pointerDown', (e) => {
				// console.log( 'POINTERDOWN EVENT' );
				const eventTarget = e.originalEvent && e.originalEvent.target
				const autoplayToggle = eventTarget && eventTarget.closest && eventTarget.closest('[data-product-video-autoplay-toggle]')
				if ( autoplayToggle ) return

				const currSlide = this.lightbox.pswp.currSlide.data
				if (currSlide.mediaType === 'video' || currSlide.mediaType === 'model' || currSlide.mediaType === 'external_video') {
					e.preventDefault()
				} else {
					// setTimeout( () => {
					// 	const variantPicker = document.querySelector('variant-picker');
					// 	if ( variantPicker ) {
					// 		variantPicker.initHijack();
					// 	}

					// 	// remove hide the counter
					// 	const counter = document.querySelector('.f-product__media-list .flickity-page-counter');
					// 	if ( counter ) {
					// 		counter.style.display = 'inline-flex';
					// 	}
					// } , 500 );
				}
			});

			this.lightbox.on('uiRegister', () => {
				if (!this.onlyImage) {
					this.lightbox.pswp.ui.registerElement({
						name: 'next',
						ariaLabel: 'Next slide',
						order: 3,
						isButton: true,
						html: '<svg class="pswp-icon-next" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
						onClick: (event, el) => {
							this.lightbox.pswp.next();
						}
					})
					this.lightbox.pswp.ui.registerElement({
						name: 'prev',
						ariaLabel: 'Previous slide',
						order: 1,
						isButton: true,
						html: '<svg class="pswp-icon-prev" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z" class="arrow"></path></svg>',
						onClick: (event, el) => {
							this.lightbox.pswp.prev();
						}
					})
				}

				this.lightbox.pswp.ui.registerElement({
					name: 'close-zoom',
					ariaLabel: 'Close zoom image',
					order: 2,
					isButton: true,
					html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="f-icon-svg f-icon--medium  f-icon-close"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
					onClick: (event, el) => {
						this.lightbox.pswp.close();

						// we have to wait for the animation to finish before we do this.
						// setTimeout( () => {
						// 	const variantPicker = document.querySelector('variant-picker');
						// 	if ( variantPicker ) {
						// 		variantPicker.initHijack();
						// 	}

						// 	// remove hide the counter
						// 	const counter = document.querySelector('.f-product__media-list .flickity-page-counter');
						// 	if ( counter ) {
						// 		counter.style.display = 'inline-flex';
						// 	}
						// } , 500 );
					}
				})
			})

			this.lightbox.init()
			this.initProductAutoplayVideoZoomControls()

			addEventDelegate({
				selector: this.selectors.toggleZoom[0],
				context: this,
				handler: (e, media) => {
					const isImage = media.dataset.mediaType === 'image'
					if (isImage) {
						const zoomMediaRoot = media.closest('.f-product__media-list');
					if (!zoomMediaRoot) return;
						const dataSource = this.buildZoomDataSource(zoomMediaRoot)
						const mediaItem = media.closest('.f-product__media')
						const mediaId = mediaItem && mediaItem.dataset.mediaId ? mediaItem.dataset.mediaId : media.dataset.mediaId
						const mediaIndex = mediaItem && mediaItem.dataset.mediaIndex ? mediaItem.dataset.mediaIndex : media.dataset.mediaIndex
						const index = dataSource.findIndex((item) => {
							if (mediaId) {
								return item.mediaId === mediaId;
							}

							return item.id === mediaIndex;
						});

						if (index < 0) return

						this.zoomMediaRoot = zoomMediaRoot
						this.lightbox.options.dataSource = dataSource
						this.lightbox.loadAndOpen(index);
						this.initProductAutoplayVideoZoomControls()

						// add hide to the counter so you dont see something like 15 / 2 when opening the zoom window.
						const counter = zoomMediaRoot.querySelector('.flickity-page-counter') || document.querySelector('.f-product__media-list .flickity-page-counter');
						if ( counter ) {
							counter.style.display = 'none';
						}
					}
				}
			})
		}

		onSlideChanged(index) {
			this.draggable = true
			this.selectedSlide = this.mediaGallery.selectedElement
			this.selectedMediaType = this.selectedSlide.dataset.mediaType
			this.selectedMediaId = this.selectedSlide.dataset.mediaId

			const mediaAspectRatio = this.selectedSlide.dataset.aspectRatio
			this.domNodes.viewer.style.setProperty('--media-aspect-ratio', mediaAspectRatio)

			if ('model,external_video,video'.includes(this.selectedMediaType) && this.draggable) {
				this.toggleDraggable()
			} else {
				this.toggleDraggable(true)
			}

			if (this.selectedMediaType === 'model') {
				this.domNodes.xrButton && this.domNodes.xrButton.setAttribute('data-shopify-model3d-id', this.selectedMediaId)
			}

			if (this.thumbnails) {
				this.thumbnails.select(index)
			}

			if (this.domNodes.sliderCounter) {
				this.domNodes.sliderCounter.textContent = index + 1
			}

			this.domNodes.mediaGallery.classList.remove('pointer-move')

			this.playActiveMedia(this.selectedSlide)
		}

		handleScreenChange() {
			document.addEventListener('matchMobile', () => {
				this.domNodes.thumbnails.update()
				if (this.thumbnails.cells.length > 4) {
					this.thumbnails.options.wrapAround = true
					this.domNodes.thumbnails.update()
				}
			})
			document.addEventListener('unmatchMobile', () => {
				this.domNodes.thumbnails.update()
				if (this.thumbnails.cells.length < 6) {
					this.thumbnails.options.wrapAround = false
					this.domNodes.thumbnails.update()
				}
			})
			if (this.thumbnails.cells.length > 5) {
				this.domNodes.thumbnails.update()
				this.thumbnails.options.wrapAround = true
				this.domNodes.thumbnails.update()
			}
		}

		toggleDraggable(status = false) {
			this.draggable = status
			this.mediaGallery.options.draggable = status
			this.mediaGallery.updateDraggable()
		}
		playActiveMedia(selected) {
			window.pauseAllMedia()
			const deferredMedia = selected.querySelector('.deferred-media')
			if (deferredMedia) deferredMedia.loadContent(false)
		}

		initProductAutoplayVideoControls(context = this) {
			const toggleSelector = '[data-product-video-autoplay-toggle]'
			const initializedKey = 'productVideoAutoplayToggleInitialized'
			const initializedValue = 'true'
			const controlsRoot = context || this
			if ( !controlsRoot.querySelectorAll ) return

			const toggleButtons = controlsRoot.querySelectorAll(toggleSelector)

			if ( !toggleButtons ) return

			toggleButtons.forEach(( button ) => {
				if ( !button ) return
				if ( button.dataset[initializedKey] === initializedValue ) return

				button.dataset[initializedKey] = initializedValue
				button.addEventListener('click', this.toggleProductAutoplayVideo.bind(this))

				const deferredMedia = button.closest('deferred-media')
				if ( !deferredMedia ) return

				const video = deferredMedia.querySelector('video')
				if ( video ) {
					this.bindProductAutoplayVideoEvents(button, video)
				}
			})
		}

		initProductAutoplayVideoZoomControls() {
			setTimeout(() => {
				const pswpElement = this.lightbox && this.lightbox.pswp && this.lightbox.pswp.element
				const zoomRoot = pswpElement || document.querySelector('.pswp')
				if ( !zoomRoot ) return

				this.initProductAutoplayVideoControls(zoomRoot)
			}, 0)
		}

		toggleProductAutoplayVideo(event) {
			event.preventDefault()
			event.stopPropagation()

			const button = event.currentTarget
			const deferredMedia = button.closest('deferred-media')
			if ( !deferredMedia ) return

			if ( !deferredMedia.getAttribute('loaded') ) {
				deferredMedia.loadContent(false)
			}

			const video = deferredMedia.querySelector('video')
			if ( !video ) return

			this.bindProductAutoplayVideoEvents(button, video)
			if ( video.paused ) {
				video.play()
			} else {
				video.pause()
			}
		}

		bindProductAutoplayVideoEvents(button, video) {
			if ( !button || !video || video.dataset.productAutoplayEventsInitialized === 'true' ) return

			video.dataset.productAutoplayEventsInitialized = 'true'
			video.addEventListener('play', () => this.updateProductAutoplayVideoControl(button, true))
			video.addEventListener('pause', () => this.updateProductAutoplayVideoControl(button, false))
		}

		updateProductAutoplayVideoControl(button, isPlaying) {
			const playIcon = button.querySelector('.product-video-autoplay-toggle__icon--play')
			const pauseIcon = button.querySelector('.product-video-autoplay-toggle__icon--pause')
			if ( !playIcon || !pauseIcon ) return

			playIcon.classList.toggle('hidden', isPlaying)
			pauseIcon.classList.toggle('hidden', !isPlaying)
			button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video')
		}

		filterVideosBySkuPrefix(skuPrefix) {
			if ( !skuPrefix ) return

			const normalizedSkuPrefix = skuPrefix.toLowerCase()
			const videoMediaSelector = '.f-product__media--video'
			const videoThumbnailSelector = '.f-product__media-thumbnails-item[data-media-type="video"]'
			const activeSliderSelector = 'flickity-component.active'
			const videoSkuPrefixKey = 'videoSkuPrefix'
			const videoMediaItems = this.querySelectorAll(videoMediaSelector)

			if ( !videoMediaItems ) return

			videoMediaItems.forEach((media) => {
				if ( !media ) return

				const mediaSkuPrefix = media.dataset[videoSkuPrefixKey]
				const shouldShow = mediaSkuPrefix === normalizedSkuPrefix
				media.style.display = shouldShow ? '' : 'none'

				if ( !shouldShow ) {
					const video = media.querySelector('video')
					if ( !video ) return
					if ( !video.paused ) video.pause()
				}
			})

			const videoThumbnailItems = this.querySelectorAll(videoThumbnailSelector)
			if ( videoThumbnailItems ) {
				videoThumbnailItems.forEach((thumbnail) => {
					if ( !thumbnail ) return

					const thumbnailSkuPrefix = thumbnail.dataset[videoSkuPrefixKey]
					const shouldShowThumbnail = thumbnailSkuPrefix === normalizedSkuPrefix
					thumbnail.style.display = shouldShowThumbnail ? '' : 'none'
				})
			}

			const activeSliders = this.querySelectorAll(activeSliderSelector)
			if ( activeSliders ) {
				activeSliders.forEach((slider) => {
					if ( !slider ) return

					const sliderInstance = slider.slider && slider.slider.instance
					if ( slider.update ) slider.update()
					if ( sliderInstance ) sliderInstance.resize()
				})
			}
		}

		setActiveMedia(mediaId) {
			const selectedMedia = this.domNodes.mediaGallery.querySelector(`[data-media-id="${mediaId}"]`)
			if (!selectedMedia) return
			const mediaIndex = Number(selectedMedia.dataset.mediaIndex)
			this.mediaGallery && this.mediaGallery.select(mediaIndex, true, false)

			this.scrollIntoView(selectedMedia)
			this.preventStickyHeader()
		}

		preventStickyHeader() {
			this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header')
			if (!this.stickyHeader) return
			this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'))
		}

		scrollIntoView(selectedMedia) {
			if (this.mediaLayout !== 'stacked' || FoxThemeSettings.isMobile) return;
			selectedMedia.scrollIntoView({
				behavior: 'smooth'
			})
		}
	})
}
